<div [formGroup]="dadDeclarationForm">
  <p style="margin-bottom: 0; line-height: 100%">
  <span style="font-size: 8pt">
    <u>
      <b>
        The section below must be signed by an officer of the Subscriber
      </b>
    </u>
  </span>
  </p>
  <br/>
  <p style="margin-bottom: 0; line-height: 100%">
  <span style="font-size: 8pt">
    <b>By completing this form and checking the checkboxes below, I confirm that:</b>
  </span>
  </p>
  <ol TYPE=a>
    <li>
      <span style="font-size: 8pt">
        <p-checkbox binary="true" formControlName="authorizationCheckbox"></p-checkbox>
        I am authorized by the Subscriber named above to confirm the
        information contained within this form
      </span>
    </li>
    <li>
      <span style="font-size: 8pt">
        <p-checkbox binary="true" formControlName="confirmationCheckbox"></p-checkbox> The # of declared <ng-container
        *ngIf="scheduleNumber === 6">Subscribers</ng-container><ng-container
        *ngIf="scheduleNumber !== 6">Accesses</ng-container> listed above is correct and that all are being Accessed at the location(s) listed above
      </span>
    </li>
    <li>
      <span style="font-size: 8pt">
        <p-checkbox binary="true" formControlName="restrictionCheckbox"></p-checkbox>
        The data is not being redistributed to and/or accessed by any third party individual/company outside of the client/company named above.
      </span>
    </li>
  </ol>
  <div *ngIf="currentDad.dadConfig.canAutoReport">
    <span>
    <b>By checking this box you are indicating that you wish to have the usage counts from this month reported automatically for future months: </b>
    <br>
    <p-checkbox binary="true" formControlName="autoReport"></p-checkbox>
    Auto Report is {{ currentDad.autoReport | autoReport }}, <ng-container
      *ngIf="currentDad.autoReport">un-</ng-container>select to turn Auto Report on for {{ currentDad?.dadConfig?.exchangeNameInTitle }}
  </span>
  </div>
  <br>

  <div>
    <div class="col-12 row">
      <div class="col-6">
        <h5>
          <b>Confirmed by:</b>
        </h5>
        <div class="form-group">
          <label for="printName">Print Name:</label>
          <div class="pl-2">
            <input [value]="printName" class="form-control" formControlName="printName" id="printName" type="text">
          </div>
        </div>
        <div class="form-group">
          <label for="dateReported">Date reported:</label>
          <div class="pl-2">
            <input class="form-control" formControlName="dateReported" id="dateReported" type="text">
          </div>
        </div>
        <div class="form-group">
          <label for="email">Email:</label>
          <div class="pl-2">
            <input class="form-control" formControlName="email" id="email" type="text">
          </div>
        </div>
        <div class="form-group">
          <label for="ip">IP Address:</label>
          <div class="pl-2">
            <input class="form-control" formControlName="ipAddress" id="ip" type="text">
          </div>
        </div>
      </div>
      <div class="col-6" *ngIf="isMckayUser || editedBy !== ''">
        <h5>
          <b>Edited by:</b>
        </h5>
        <div class="form-group">
          <label for="editedBy">Mckay admin: </label>
          <div class="pl-2">
            <input class="form-control" formControlName="editedBy" id="editedBy" type="text">
          </div>
        </div>
        <div class="form-group" *ngIf="isMckayUser">
          <label for="editedAt">Edited at:</label>
          <div class="pl-2">
            <input class="form-control" formControlName="editedAt" id="editedAt" type="text">
          </div>
        </div>
        <div class="form-group" *ngIf="isMckayUser">
          <label for="mckayComment">Mckay comment:</label>
          <div class="pl-2">
            <textarea class="form-control" formControlName="mckayComment" id="mckayComment"
                      style="height: 113px"> </textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="this.currentDad.largeCountDifferenceExplanation">
  <b>Reason for count change:</b> {{ this.currentDad.largeCountDifferenceExplanation }}
  <br>
  <br>
</div>
